export class OrderListRequestModel {
    days!: string;
    awsuserid!: string;
    orderstatus!: string;
    startDate!: string;
    endDate!: string;
    userid!: string;
}

